'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import MarkAsReceivedConfirmationModal from '../MarkAsReceivedConfirmationModal'

type Props = ConversationActionProps

const MarkAsDelivered = ({ title, primary, size, theme, inverse }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const shipmentId = conversation?.transaction?.shipment?.id
  const userSide = conversation?.transaction?.userSide

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const handleConfirmationOpen = () => setIsConfirmationOpen(true)

  const handleConfirmationClose = () => setIsConfirmationOpen(false)

  if (!transactionId || !shipmentId) return null

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleConfirmationOpen}
      />
      <MarkAsReceivedConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleConfirmationClose}
        transactionId={transactionId}
        shipmentId={shipmentId}
        screen="message_reply"
        userSide={userSide}
      />
    </>
  )
}

export default MarkAsDelivered
